import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, Box } from '@mui/material';
const EventRegistrationContentCard = ({ children, sx }) => (_jsx(Box, { sx: {
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        position: 'relative',
        border: `1px solid ${alpha('#2D3077', 0.2)}`,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        height: '100%',
        overflow: 'hidden',
        ...sx
    }, children: children }));
export default EventRegistrationContentCard;
